import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, ModalBody, Row, Col } from 'reactstrap';
import { ReactComponent as WandIcon } from '../../../assets/images/wand.svg';
import { ReactComponent as BillsIcon } from '../../../assets/images/bills.svg';
import { ReactComponent as CheckmarkIcon } from '../../../assets/images/checkmark-badge.svg';
import { ReactComponent as HourGlassIcon } from '../../../assets/images/hourglass.svg';
import { ReactComponent as PiggyBankIcon } from '../../../assets/images/piggy-bank.svg';
import { ReactComponent as RefrigeratorDollarIcon } from '../../../assets/images/refrigerator-dollarsign.svg';
import { ReactComponent as ServicerIcon } from '../../../assets/images/servicer.svg';
import { ReactComponent as SupportIcon } from '../../../assets/images/support.svg';
import { ReactComponent as NJRLogo } from '../../../assets/images/Vendor/NJR/njr-retail-logo.svg';
import classNames from 'classnames';
import styles from './PlanBenefitsModal.module.css';
import NJRTermsDocument from '../../../assets/Documents/NJR/njr-serviceplan-terms.pdf';
import ClientPhone from '../../shared/ClientPhone';

const PlanBenefitsModal = ({ isOpen, toggle, centered }) => {
    const [modal, setModal] = useState(isOpen);
    const [tsf, setLowerTsf] = useState([]);
    useEffect(() => {
        fetch(`api/pricing/RiskProfile/GetByMasterProgramId/20/16/${'njr'}`)
            .then((res) => res.json())
            .then((data) => {
                var lowerTsfValue = data[0].tsf;
                const lsfValue = Math.min(...lowerTsfValue);
                setLowerTsf(lsfValue);
            });
    }, []);

    const benefits = [
        {
            image: <CheckmarkIcon />,
            title: 'Mechanical and Electrical Failures',
            desc: 'Covers repairs for normal wear and tear, includes parts and labor.'
        },
        {
            image: <HourGlassIcon />,
            title: 'Covers Older Products',
            desc: 'Age of system or appliance doesn’t matter! We have you covered.'
        },
        {
            image: <PiggyBankIcon />,
            title: 'Save on Repairs',
            desc: 'Helps prevent you from paying expensive repair costs.'
        },
        {
            image: <SupportIcon />,
            title: 'Easy Claims Process',
            desc: (
                <>
                    Simply call <ClientPhone department='claim' /> and speak to a customer care agent.
                </>
            )
        },
        {
            image: <RefrigeratorDollarIcon />,
            title: 'Service Fee Options',
            desc: `Choose your preferred service fee - starting as low as $${tsf}.`
        },
        {
            image: <ServicerIcon />,
            title: 'Knowledgeable, Courteous Techs',
            desc: ' Professional service provided by local service technicians.'
        },
        {
            image: <WandIcon />,
            title: 'Quick Diagnosis',
            desc: 'Authorized technicians will diagnose and make the repair.'
        },
        {
            image: <BillsIcon />,
            title: 'Payment Options',
            desc: 'Two convenient payment options available - monthly or yearly.'
        }
    ];

    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={centered}
            className={classNames('modal-lg', styles.planBenefitsModal)}
            aria-labelledBy='planBenefits'
        >
            <div className={styles.pbModalHeader}>
                <span className={styles.njrLogo}>
                    <NJRLogo />
                </span>
                <h1
                    className='h4'
                    id='planBenefits'
                >
                    {' '}
                    Service Plan Benefits*
                </h1>
                <p>Our plans provide the most reliable care for the appliances you rely on every day.</p>
            </div>
            <ModalBody className={styles.pbModalBody}>
                <Row className='m-0'>
                    {benefits.map((benefit) => (
                        <Col
                            className={styles.benefitCol}
                            lg='4'
                            md='6'
                        >
                            <div className={styles.innerDiv}>
                                <span className={styles.benefitIcon}>{benefit.image}</span>
                                <h2 className='h6'>{benefit.title}</h2>
                                <p className='mb-0'>{benefit.desc}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </ModalBody>
            <div className={styles.terms}>
                <sup>*</sup>Limitations and exclusions apply. See the complete{' '}
                <a
                    tabIndex={0}
                    className={styles.link}
                    aria-label='click to open terms and conditions for njr retail services'
                    onClick={() => window.open(NJRTermsDocument)}
                >
                    terms and conditions
                </a>
                .
            </div>
            <div className={styles.pbModalFooter}>
                <div>
                    <button
                        className='btn btnLink'
                        onClick={toggle}
                    >
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PlanBenefitsModal;
